<template>
    <div>
        <oraclePartner/>
        <openKmPartner/>
    </div>
</template>

<script src="./partners"></script>
<style src="./partners.css"></style>